import React, { Component } from "react";
import "../css/favoritePlans.css";
import Favorite from './Favorite';

import ReactGA from 'react-ga';

class FavoritePlans extends Component {

    constructor(props) {
        super(props);
        this.state = {
            favorites: [],
            email: "",
            mailInputColor: "normal"
        }
    }

    render() {
        return (
            <div style={{ paddingTop: "45px", paddingBottom: "20px" }}>
                {this.renderEmailForm()}
                {this.state.favorites}
            </div>
        );
    }

    renderEmailForm = () => {
        var mailInputColor = "mailInput";
        if (this.state.mailInputColor == "red") {
            mailInputColor = "mailInputRed";
        }

        if (this.state.favorites !== []) {
            return (
                <div className="mailEntryHolder">
                    <div style={{ fontSize: "17px", padding: "5px", color: "#fff" }}>Don't lose your favorites! Email this list by using the form below.</div>
                    <div style={{ display: "flex", flexDirection: "row", padding: "5px" }}>
                        <input
                            type="email"
                            className={mailInputColor}
                            placeholder="Email Address.."
                            value={this.state.email}
                            onChange={e => {
                                this.setState({
                                    email: e.target.value,
                                    mailInputColor: "normal"
                                });
                            }}
                        />
                        <div onClick={() => { this.sendFavorites() }} className="sendButton">Send</div>
                    </div>
                </div>
            );
        }
    }

    sendFavorites = () => {

        if (this.state.email !== "") {

            var favorites = localStorage.getItem('favorites');

            //make sure there's a trailing comma in case it was removed by the email client, pops the array on the server
            favorites = favorites + ",";
            favorites = favorites.replace(",,", ",");

            var url = "https://www.houseplanstore.com/web_api/?v=sendFavorites&planIds=" + favorites + "&email=" + this.state.email;
            console.log(url)
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.onload = function (e) {
                alert("Your favorites have been sent to " + this.state.email + ". It may take a minute for the email to arrive. Please also check your spam folder.");
                this.setState({ email: "" });
                ReactGA.event({
                    category: 'User',
                    action: 'Sent Favorites'
                });
            }.bind(this)
            xhr.send();
        } else {
            this.setState({
                mailInputColor: "red"
            })
        }
    }

    getFavoritePlans = (favorites) => {
        if (!!favorites) {
            var url = "https://www.houseplanstore.com/web_api/?v=getFavoritePlans&planIds=" + favorites;
            //console.log(url)
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.onload = function (e) {
                try {
                    //console.log(xhr.responseText);
                    if (xhr.responseText == "" || xhr.responseText == "null") {
                        return;
                    }
                    var json = JSON.parse(xhr.responseText);
                    var favoriteDataItems = [];
                    for (var i = 0; i < Object.keys(json).length; i++) {
                        favoriteDataItems.push(<Favorite key={i} item={json[i]} />);
                    }
                    //console.log(dataItems);
                    this.setState({
                        favorites: [...this.state.favorites, ...favoriteDataItems]
                    })
                } catch (err) {
                    console.log(err);
                }
            }.bind(this)
            xhr.send();
        }
    }

    getUrlVars = () => {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    componentDidMount() {

        var favorites = localStorage.getItem('favorites');
        this.getFavoritePlans(favorites);

        ReactGA.pageview('/webapp/favorite_plans/');

    }
}

export default FavoritePlans;